export const getters = {
    list: state => state.list,
   
    columns: state => state.columns,
    model: state => state.model,
    header_model: state => state.header_model,
    filter: state => state.filter,
    pagination: state => state.pagination,
    sort: state => state.sort,
    rules: state => state.rules,
    selected_partner_doctor: state => state.selected_partner_doctor,
};
